import { render, staticRenderFns } from "./MyTemplate.vue?vue&type=template&id=68057f93&scoped=true"
import script from "./MyTemplate.vue?vue&type=script&lang=js"
export * from "./MyTemplate.vue?vue&type=script&lang=js"
import style0 from "./MyTemplate.vue?vue&type=style&index=0&id=68057f93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68057f93",
  null
  
)

export default component.exports